<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.qry'>
          <button :title='$t("TS.ts_search")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
        <div v-if='btns.save'>
          <button :title='$t("保存")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("save")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'VpnCallMenuButton',
  data() {
    return {
      btns: {
        save: true,
        qry: true,
        export: true
      }
    };
  },
  methods: {
    buttonClk(args) {
      console.log(args);
      this.$emit('methodEnum', args);
    }
  }
};
</script>

<style scoped>

</style>
